import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { UsersAutocomplete } from "@shared/components/AutocompleteFields";

export function PartnerForm() {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 6 }}>
        <Form.Input name="name" label={translate("v1/partner_admin.fields.name")} required />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input name="email" label={translate("v1/partner_admin.fields.email")} required />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="telephone"
          label={translate("v1/partner_admin.fields.telephone")}
          mask="cell"
          required
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Input
          name="document"
          label={translate("v1/partner_admin.fields.document")}
          required
        />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <UsersAutocomplete name="user" label={translate("v1/partner_admin.fields.user")} />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Form.Switch name="active" label={translate("v1/partner_admin.fields.active")} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="notes"
          label={translate("v1/partner_admin.fields.notes")}
          multiline
          minRows={4}
        />
      </Grid>
    </Grid>
  );
}
